import { format, isBefore, isSameDay } from 'date-fns';

export const formatMessageEventCardDates = (startTime: string, endTime: string): { monthDay: string; time: string } => {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const timezone = new Date(startTime)
    .toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' })
    .substring(4);

  if (isSameDay(start, end)) {
    // -
    return {
      monthDay: `${format(start, 'eee MMM dd')}`,
      time: `${format(start, 'h:mm')} - ${format(end, 'h:mm')}${format(end, 'a').toLowerCase()} ${timezone}`,
    };
  } else {
    return {
      monthDay: `${format(start, 'eee MMM dd')}`,
      time: `${format(start, 'h:mm')}${format(start, 'a').toLowerCase()} - ${format(end, 'MMM dd')}, ${format(
        end,
        'h:mm',
      )}${format(end, 'a').toLowerCase()} ${timezone}`,
    };
  }
};

export const formatInviteEventDate = (startTime: string, endTime: string): string => {
  const { monthDay, time } = formatMessageEventCardDates(startTime, endTime);
  return `${monthDay}, ${time}`;
};

export const formatEventCardTeaser = (startTime: string, endTime: string): string => {
  try {
    const eventStartDate = new Date(startTime);
    const start = isBefore(eventStartDate, new Date()) ? new Date() : eventStartDate;

    if (!isSameDay(eventStartDate, new Date(endTime))) {
      return `${format(start, 'eeee, LLLL do')} – ${format(new Date(endTime), 'eeee, LLLL do')}`;
    } else {
      return `${format(start, 'eeee, LLLL do')}`;
    }
  } catch {
    return startTime;
  }
};

export const formatEventInviteDateV2 = (startTime: string, endTime: string): { monthDay: string; time: string } => {
  // output like two components:
  // first: Tuesday,  Dec 17th
  // second: 10:00am - 11:00am
  const start = new Date(startTime);
  const end = new Date(endTime);
  const timezone = new Date(startTime)
    .toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' })
    .substring(4);

  if (isSameDay(start, end)) {
    return {
      // like "Tuesday, Dec 17th"
      monthDay: `${format(start, 'EEEE, MMM do')}`,
      time: `${format(start, 'h:mm')}${format(start, 'a').toLowerCase()} — ${format(end, 'h:mm')}${format(
        end,
        'a',
      ).toLowerCase()} ${timezone}`,
    };
  }
  return {
    monthDay: `${format(start, 'EEEE, MMM do')},`,
    time: `${format(start, 'h:mm')}${format(start, 'a').toLowerCase()} — ${format(end, 'MMM dd')}, ${format(
      end,
      'h:mm',
    )}${format(end, 'a').toLowerCase()} ${timezone}`,
  };
};
